  document.addEventListener("DOMContentLoaded", () => {
    handleProductSlider();
  });
  const handleProductSlider = () => {
    const productSliderThumb = new Swiper(".product-slider__thumb", {
      spaceBetween: 16,
      slidesPerView: "auto",
      loop:true,
      breakpoints: {
        0: {
          spaceBetween: 8,
        },
        768: {
          spaceBetween: 16,
        },
      },
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
    });
    const productSliderMain = new Swiper(".product-slider__main", {
      spaceBetween: 16,
      fadeEffect: {
        crossFade: true,
      },
      effect: "fade",
      loop: true,
      thumbs: {
        swiper: productSliderThumb,
      },
    });
  };